import React, { useState, useEffect, useRef } from "react"
const TypingEffect = ({ text, speed, messagesEndRef }) => {
	const [displayText, setDisplayText] = useState("")
	const containerRef = useRef(null)
	useEffect(() => {
		const element = document.getElementsByClassName("scroll-to-bottom")[0]

		let currentIndex = 0
		const interval = setInterval(() => {
			setDisplayText(text.substring(0, currentIndex))
			element.scrollTop = element.scrollHeight
			currentIndex++
			if (currentIndex > text.length) {
				clearInterval(interval)
			}
		}, speed)
		return () => clearInterval(interval)
	}, [text, speed])
	return (
		<div ref={containerRef} style={{ maxHeight: "100%" }}>
			<span>{displayText}</span>
		</div>
	)
}
export default TypingEffect
